import React from 'react';
import SponsorInfoDetailsContainer from '../../../Containers/UserContainer/SponsorInfoDetails';

const SponsorInfoDetailsScreen = () => {
  return <SponsorInfoDetailsContainer />;
};

export default SponsorInfoDetailsScreen;
